export function hasLivePolicyData(liveSubmission) {
  return Boolean(liveSubmission?.submissionStatus);
}

export function buildPolicyPayload({ internalQuote, liveSubmission }) {
  const localQuote = internalQuote?.quote || {};
  const localInsured = localQuote?.insuredInformation || {};
  const liveInsured = liveSubmission?.insuredInformation || {};

  return {
    ...internalQuote,
    ...liveSubmission,
    insuredInformation: {
      ...localInsured,
      ...liveInsured,
      legal_name:
        liveInsured.legal_name ||
        localInsured.legalName ||
        internalQuote?.companyData?.name ||
        "",
    },
    dot_number:
      liveSubmission?.dot_number ||
      internalQuote?.dot_number ||
      localInsured.dotNumber ||
      "",
    effective_date:
      liveSubmission?.effective_date ||
      internalQuote?.effective_date ||
      null,
  };
}
